import { useState, useEffect, useCallback } from 'react';

/**
 * Gestisce lo stato di aperto/chiuso di un menù.
 * Se l'utente fa un click il menù si chiude.
 * @param {func} onOpen callback chiamata all'apertura del menù.
 * @param {func} onClose callback chiamata alla chiusura del menù.
 * @param {object} doc web page document (solo ad uso TEST).
 * @returns {{open, onOpen, onClose}} oggetto con stato aperto/chiuso e funzioni per cambiarlo.
 */
function useMenuOpenState({ onOpen: onOpenCB, onClose: onCloseCB } = {}, doc = document) {
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(() => {
    setOpen(true);
    onOpenCB && onOpenCB();
  }, [onOpenCB]);
  const onClose = useCallback(() => {
    setOpen(false);
    onCloseCB && onCloseCB();
  }, [onCloseCB]);

  useEffect(() => {
    if (!open) return undefined;
    doc.addEventListener('click', onClose);
    return () => {
      doc.removeEventListener('click', onClose);
    };
  }, [doc, open, onClose]);

  return { open, onOpen, onClose };
}

export default useMenuOpenState;
